__turbopack_context__.v({
  "lotteryInfoContainer": "LotteryInfo-module__tq61Cq__lotteryInfoContainer",
  "lotteryInfoText": "LotteryInfo-module__tq61Cq__lotteryInfoText",
});
